import { usePayPhoneBox } from '../../utils/usePayPhone';

const PayPhoneBox = ({
    amount,
    amountWithTax,
    amountWithoutTax,
    tax,
    hidden,
    clientTransactionId,
    companyId,
}) => {
    const containerId = `pp-button-${companyId || 'default'}`;

    usePayPhoneBox({
        amount,
        amountWithTax,
        amountWithoutTax,
        tax,
        clientTransactionId,
        companyId,
        containerId,
    });

    return <div hidden={hidden} id={containerId}></div>;
};

export default PayPhoneBox;
